export default (path) => {
  const customizedPath = 'customizing/' + path;
  return import('../' + customizedPath + '.vue').then((component) => {
    return component;
  }).catch(() => {
    return import('../' + path + '.vue');
  });
};
